// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description-con[data-v-7d28d5b3] {\n  margin-bottom: 13px;\n}\n.description-con .value[data-v-7d28d5b3] {\n  width: 45px;\n}", ""]);
// Exports
module.exports = exports;
